import { AxiosError } from "axios";
import api from "../../services/api";
import styled, { keyframes, css } from "styled-components";
import logo from "../../assets/logo.jpg";
import { useState } from "react";
import { Redirect } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactInputMask from "react-input-mask";
import ModalAlerta from "../../components/modal";
import { useAppSelector } from "../../store/hooks";
import ModalAviso from "../../components/modal-aviso";
import { Form } from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import { tokenExpirado } from "../../services/seguranca";
import VerificacaoModal from "../../components/verificacao-modal";
import ProgressBarModal from "../../components/progressbar-relatorio";
import { tratarErroApi } from "../../services/utilitarios";
import { AcessoProps, ApiError, FormCadastrar, CadastrarSistema } from "../../services/tipos";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash, FaUser, FaIdCard, FaPhone, FaBuilding, FaArrowRight, FaArrowLeft, FaCheck, FaRocket, FaCar, FaChartBar, FaMobileAlt, FaCogs } from "react-icons/fa";
import { toast } from "react-toastify";

// ================= ANIMACOES =================
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
`;

const slideIn = keyframes`
  from { opacity: 0; transform: translateX(16px); }
  to { opacity: 1; transform: translateX(0); }
`;

const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-12px); }
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const gradientShift = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const progressPulse = keyframes`
  0%, 100% { box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.3); }
  50% { box-shadow: 0 0 0 6px rgba(59, 130, 246, 0); }
`;

// ================= LAYOUT =================
const PageWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  width: 100%;
  background: #ffffff;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

// ================= PAINEL ESQUERDO =================
const LeftPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 50px;
  background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #1a56db 100%);
  background-size: 200% 200%;
  animation: ${gradientShift} 10s ease infinite;
  position: relative;
  overflow: hidden;

  @media (max-width: 960px) {
    display: none;
  }
`;

const LeftOverlay = styled.div`
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 20% 40%, rgba(59, 130, 246, 0.12) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(99, 102, 241, 0.08) 0%, transparent 50%);
`;

const FloatingCircle = styled.div<{ size: string; top: string; left: string; delay: string }>`
  position: absolute;
  width: ${p => p.size};
  height: ${p => p.size};
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.04);
  top: ${p => p.top};
  left: ${p => p.left};
  animation: ${float} 7s ease-in-out infinite;
  animation-delay: ${p => p.delay};
`;

const LeftContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 420px;
  animation: ${fadeIn} 0.6s ease-out;
`;

const LeftLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 48px;
`;

const LeftLogoImg = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
`;

const LeftLogoText = styled.span`
  font-size: 1.5rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.5px;
  font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif;
`;

const LeftStepInfo = styled.div`
  animation: ${slideIn} 0.4s ease-out;
`;

const LeftStepNumber = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #93c5fd;
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 20px;
`;

const LeftTitle = styled.h2`
  font-size: 2rem;
  font-weight: 800;
  color: #ffffff;
  margin: 0 0 12px;
  line-height: 1.2;
  letter-spacing: -0.5px;
  font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif;
`;

const LeftDescription = styled.p`
  font-size: 1.05rem;
  color: rgba(255, 255, 255, 0.65);
  margin: 0 0 36px;
  line-height: 1.6;
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

const FeatureCard = styled.div`
  padding: 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.06);
`;

const FeatureCardIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #60a5fa;
  font-size: 0.95rem;
  margin-bottom: 10px;
`;

const FeatureCardTitle = styled.span`
  font-size: 0.82rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  display: block;
  margin-bottom: 2px;
`;

const FeatureCardDesc = styled.span`
  font-size: 0.72rem;
  color: rgba(255, 255, 255, 0.4);
`;


// ================= PAINEL DIREITO =================
const RightPanel = styled.div`
  width: 560px;
  min-width: 560px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 48px 56px;
  background: #ffffff;
  overflow-y: auto;

  @media (max-width: 960px) {
    width: 100%;
    min-width: unset;
    flex: 1;
    padding: 28px 20px;
  }
`;

const MobileLogo = styled.div`
  display: none;
  align-items: center;
  gap: 10px;
  margin-bottom: 24px;

  @media (max-width: 960px) {
    display: flex;
  }
`;

const MobileLogoImg = styled.img`
  width: 34px;
  height: 34px;
  border-radius: 9px;
`;

const MobileLogoText = styled.span`
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f172a;
  font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif;
`;

const FormContainer = styled.div`
  width: 100%;
  max-width: 440px;
  animation: ${fadeIn} 0.5s ease-out;

  @media (max-width: 960px) {
    max-width: 100%;
  }
`;

// ================= PROGRESS BAR =================
const ProgressBar = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 36px;
`;

const ProgressSegment = styled.div<{ active: boolean; done: boolean }>`
  flex: 1;
  height: 4px;
  border-radius: 2px;
  background: ${p => p.done ? '#22c55e' : p.active ? '#3b82f6' : '#e2e8f0'};
  transition: all 0.4s ease;
  position: relative;

  ${p => p.active && css`animation: ${progressPulse} 2s ease-in-out infinite;`}
`;

const ProgressLabels = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
`;

const ProgressLabel = styled.span<{ active: boolean }>`
  font-size: 0.72rem;
  font-weight: ${p => p.active ? '600' : '400'};
  color: ${p => p.active ? '#0f172a' : '#94a3b8'};
  transition: all 0.3s ease;
`;

// ================= TOGGLE PF/PJ =================
const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
`;

const ToggleContainer = styled.div`
  display: flex;
  background: #f1f5f9;
  border-radius: 10px;
  padding: 3px;
`;

const ToggleOption = styled.button<{ active: boolean }>`
  padding: 7px 18px;
  border: none;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${p => p.active ? '#ffffff' : 'transparent'};
  color: ${p => p.active ? '#0f172a' : '#94a3b8'};
  box-shadow: ${p => p.active ? '0 1px 3px rgba(0,0,0,0.08)' : 'none'};
`;

// ================= HEADER DO STEP =================
const StepHeader = styled.div`
  margin-bottom: 24px;
`;

const StepTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 4px;
  font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif;
`;

const StepDescription = styled.p`
  font-size: 0.88rem;
  color: #64748b;
  margin: 0;
`;

// ================= FORM FIELDS =================
const FieldGroup = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  font-size: 0.82rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
`;

const InputWrapper = styled.div`
  position: relative;
`;

const inputStyles = css`
  width: 100%;
  padding: 12px 14px 12px 42px;
  font-size: 0.95rem;
  border-radius: 10px;
  border: 1.5px solid #e2e8f0;
  box-sizing: border-box;
  transition: all 0.2s ease;
  background: #ffffff;
  color: #0f172a;

  &:focus {
    border-color: #3b82f6;
    outline: none;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  &::placeholder { color: #94a3b8; }
  &:disabled { background: #f8fafc; color: #64748b; }
`;

const Input = styled.input`${inputStyles}`;
const MaskedInput = styled(ReactInputMask)`${inputStyles}`;

const Icon = styled.span`
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #cbd5e1;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
`;

const TogglePasswordIcon = styled.span`
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 0.9rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  &:hover { color: #64748b; }
`;

const SmallSpinner = styled.div`
  width: 14px;
  height: 14px;
  border: 2px solid #e2e8f0;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: ${spin} 0.5s linear infinite;
  display: inline-block;
  margin-left: 6px;
`;

const Badge = styled.div<{ type: 'success' | 'error' | 'loading' }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 0.78rem;
  font-weight: 500;
  margin-top: 8px;
  background: ${p => p.type === 'success' ? '#f0fdf4' : p.type === 'error' ? '#fef2f2' : '#eff6ff'};
  color: ${p => p.type === 'success' ? '#166534' : p.type === 'error' ? '#991b1b' : '#1e40af'};
`;

const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 0;
  }
`;

// ================= BUTTONS =================
const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 32px;
`;

const BtnPrimary = styled.button`
  flex: 1;
  padding: 13px;
  border: none;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
  background: #3b82f6;
  color: #ffffff;

  &:hover { background: #2563eb; transform: translateY(-1px); }
  &:disabled { background: #cbd5e1; cursor: not-allowed; transform: none; }
`;

const BtnSecondary = styled.button`
  padding: 13px 22px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #ffffff;
  color: #475569;

  &:hover { background: #f8fafc; border-color: #cbd5e1; }
`;

// ================= FOOTER =================
const FooterLink = styled.p`
  font-size: 0.88rem;
  color: #64748b;
  margin: 24px 0 0;
  text-align: center;

  a {
    color: #3b82f6;
    text-decoration: none;
    font-weight: 600;
    &:hover { color: #1d4ed8; }
  }
`;

const TermsText = styled.p`
  font-size: 0.78rem;
  color: #94a3b8;
  margin: 16px 0 0;
  line-height: 1.5;

  a {
    color: #3b82f6;
    text-decoration: none;
    &:hover { text-decoration: underline; }
  }
`;

const StepContent = styled.div`
  animation: ${slideIn} 0.3s ease-out;
`;

// ================= VALIDACOES =================
function validarCPF(cpf: string): boolean {
  cpf = cpf.replace(/\D/g, '');
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
  let soma = 0;
  for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
  let resto = 11 - (soma % 11);
  if ((resto >= 10 ? 0 : resto) !== parseInt(cpf.charAt(9))) return false;
  soma = 0;
  for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
  resto = 11 - (soma % 11);
  return (resto >= 10 ? 0 : resto) === parseInt(cpf.charAt(10));
}

function validarCNPJ(cnpj: string): boolean {
  cnpj = cnpj.replace(/\D/g, '');
  if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;
  let t = cnpj.length - 2, n = cnpj.substring(0, t), d = cnpj.substring(t), s = 0, p = t - 7;
  for (let i = t; i >= 1; i--) { s += parseInt(n.charAt(t - i)) * p--; if (p < 2) p = 9; }
  let r = s % 11 < 2 ? 0 : 11 - (s % 11);
  if (r !== parseInt(d.charAt(0))) return false;
  t += 1; n = cnpj.substring(0, t); s = 0; p = t - 7;
  for (let i = t; i >= 1; i--) { s += parseInt(n.charAt(t - i)) * p--; if (p < 2) p = 9; }
  r = s % 11 < 2 ? 0 : 11 - (s % 11);
  return r === parseInt(d.charAt(1));
}

// ================= DADOS DO PAINEL ESQUERDO POR STEP =================
const stepLeftContent = [
  {
    badge: 'Passo 1 de 3',
    title: 'Configure sua locadora',
    description: 'Em poucos minutos você terá acesso a todas as ferramentas para gerenciar seus veículos, contratos e clientes.',
    type: 'features' as const,
  },
  {
    badge: 'Passo 2 de 3',
    title: 'Quase lá!',
    description: 'Precisamos dos seus dados para criar o acesso de administrador. Você poderá adicionar mais usuários depois.',
    type: 'ready' as const,
  },
  {
    badge: 'Passo 3 de 3',
    title: 'Último passo!',
    description: 'Defina uma senha segura e comece a explorar o sistema. Você terá acesso completo para testar todas as funcionalidades.',
    type: 'ready' as const,
  },
];

// ================= COMPONENTE =================
function Cadastrar(props: AcessoProps) {
  const [step, setStep] = useState(1);
  const [tipoPessoa, setTipoPessoa] = useState<'PJ' | 'PF'>('PJ');
  const [timer, setTimer] = useState(300);
  const [emailInput, setEmailInput] = useState('');
  const [senhaInput, setSenhaInput] = useState('');
  const [showAlerta, setShowAlerta] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [isCodeValid, setIsCodeValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [confirmaSenhaInput, setConfirmaSenha] = useState('');
  const [showModalAviso, setShowModalAviso] = useState(false);
  const [nomeEmpresaInput, setNomeEmpresaInput] = useState('');
  const [messageAviso, setMessageAviso] = useState<string>('');
  const [messageAlerta, setMessageAlerta] = useState<string[]>([]);
  const [documentoInput, setDocumentoInput] = useState<string>('');
  const [nomeUsuarioInput, setNomeUsuarioInput] = useState<string>('');
  const [telefoneInput, setTelefoneInput] = useState<string>('');
  const [token] = useState<string>(useAppSelector(state => state.token));
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [logado] = useState<boolean>(useAppSelector(state => state.logado));
  const [tipoModalAviso, setTipoModalAviso] = useState<'aprovado' | 'recusado' | 'pendente'>('recusado');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [documentoValido, setDocumentoValido] = useState(false);
  const [buscandoCnpj, setBuscandoCnpj] = useState(false);
  const [cnpjStatus, setCnpjStatus] = useState<'idle' | 'loading' | 'found' | 'not_found'>('idle');
  const [quantidadeVeiculosInput, setQuantidadeVeiculosInput] = useState<number>(0);

  const { register, handleSubmit } = useForm<FormCadastrar>();

  const [codigoAfiliado] = useState(() => new URLSearchParams(window.location.search).get("ref") || '');

  const handleTipoPessoaChange = (tipo: 'PJ' | 'PF') => {
    setTipoPessoa(tipo);
    setDocumentoInput('');
    setDocumentoValido(false);
    setNomeEmpresaInput('');
    setCnpjStatus('idle');
  };

  const formatarDocumento = (documento: string) => {
    const num = documento.replace(/\D/g, '');
    if (tipoPessoa === 'PF') {
      return num.slice(0, 11).replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    return num.slice(0, 14).replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  };

  const validarDocumento = (doc: string): boolean => {
    const num = doc.replace(/\D/g, '');
    if (tipoPessoa === 'PF' && num.length === 11) return validarCPF(doc);
    if (tipoPessoa === 'PJ' && num.length === 14) return validarCNPJ(doc);
    return false;
  };

  const handleDocumentoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = formatarDocumento(e.target.value);
    setDocumentoInput(val);
    setCnpjStatus('idle');
    const num = val.replace(/\D/g, '');
    const expected = tipoPessoa === 'PF' ? 11 : 14;
    setDocumentoValido(num.length === expected && validarDocumento(val));
  };

  const handleDocumentoBlur = () => {
    const num = documentoInput.replace(/\D/g, '');
    if (tipoPessoa === 'PJ' && num.length === 14 && validarDocumento(documentoInput)) {
      buscarCnpj(num);
    }
  };

  const buscarCnpj = async (cnpj: string) => {
    setBuscandoCnpj(true);
    setCnpjStatus('loading');
    try {
      const res = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${cnpj}`);
      if (res.ok) {
        const data = await res.json();
        const nome = data.nome_fantasia || data.razao_social || '';
        if (nome) {
          setNomeEmpresaInput(nome);
          setCnpjStatus('found');
          toast.success('Dados da empresa preenchidos!');
        } else { setCnpjStatus('not_found'); }
      } else { setCnpjStatus('not_found'); }
    } catch { setCnpjStatus('not_found'); }
    finally { setBuscandoCnpj(false); }
  };

  async function emailJaCadastrado(email: string): Promise<boolean> {
    try { return Boolean((await api.get(`/Usuario/EmailJaCadastrado/${email}`)).data); }
    catch (e: any) { tratarErro(e); return false; }
  }

  async function documentoJaCadastrado(doc: string): Promise<boolean> {
    try { return Boolean((await api.get(`/Empresa/DocumentoJaCadastrado/${encodeURIComponent(doc.replace(/\D/g, ''))}`)).data); }
    catch (e: any) { tratarErro(e); return false; }
  }

  const isStep1Valid = () => documentoInput.trim() && documentoValido && nomeEmpresaInput.trim() && !buscandoCnpj && quantidadeVeiculosInput > 0;
  const isStep2Valid = () => nomeUsuarioInput.trim() && telefoneInput.replace(/\D/g, '').length === 11 && emailInput.trim();
  const isStep3Valid = () => senhaInput.length >= 6 && confirmaSenhaInput.trim() && senhaInput === confirmaSenhaInput;

  const nextStep = async () => {
    if (step === 1) {
      setCarregando(true);
      const exists = await documentoJaCadastrado(documentoInput);
      setCarregando(false);
      if (exists) { setMessageAlerta(['Esse documento já está cadastrado!']); setShowAlerta(true); return; }
      setStep(2);
    } else if (step === 2) {
      setCarregando(true);
      const exists = await emailJaCadastrado(emailInput);
      setCarregando(false);
      if (exists) { setMessageAlerta(['Esse e-mail já está cadastrado!']); setShowAlerta(true); return; }
      setStep(3);
    }
  };

  const prevStep = () => { if (step > 1) setStep(step - 1); };

  const onSubmit: SubmitHandler<FormCadastrar> = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    if (senhaInput !== confirmaSenhaInput) {
      setMessageAlerta(['As senhas não coincidem']); setShowAlerta(true); setIsSubmitting(false); return;
    }
    if (!isCodeValid) await gerarCodigoVerificacao();
    setIsSubmitting(false);
  };

  async function gerarCodigoVerificacao() {
    setCarregando(true);
    try {
      const cadastro: CadastrarSistema = {
        email: emailInput, senha: senhaInput, nomeEmpresa: nomeEmpresaInput,
        documento: documentoInput.replace(/\D/g, ''), nomeUsuario: nomeUsuarioInput,
        telefone: telefoneInput.replace(/\D/g, ''), quantidadeVeiculos: quantidadeVeiculosInput,
        codigoAfiliado: codigoAfiliado || undefined,
      };
      const res = await api.post('/GerarCodigoDeVerificacao/', cadastro);
      if (res.status === 200) { setShowVerificationModal(true); startTimer(); }
    } catch {
      setMessageAlerta(['Aguarde 5 minutos antes de solicitar um novo código.']);
      setShowVerificationModal(true); setShowAlerta(true);
    } finally { setCarregando(false); }
  }

  const validarCodigo = async (codigo: string) => {
    if (carregando) return;
    setCarregando(true);
    try {
      const cadastro: CadastrarSistema = {
        email: emailInput, senha: senhaInput, nomeEmpresa: nomeEmpresaInput,
        documento: documentoInput.replace(/\D/g, ''), nomeUsuario: nomeUsuarioInput,
        telefone: telefoneInput.replace(/\D/g, ''), quantidadeVeiculos: quantidadeVeiculosInput,
        codigoAfiliado: codigoAfiliado || undefined,
      };
      const res = await api.post(`/ValidarCodigoDeVerificacao/${codigo}`, cadastro);
      if (res.status === 200) {
        setIsCodeValid(true); setShowVerificationModal(false);
        setTipoModalAviso('aprovado'); setMessageAviso('Cadastro realizado com sucesso!'); setShowModalAviso(true);
      }
    } catch (error: any) {
      if (!isCodeValid) {
        const msg = error?.response?.data?.Mensagem || 'Código inválido ou expirado';
        setMessageAlerta([msg]); setShowAlerta(true);
      }
      setShowVerificationModal(false);
    } finally { setCarregando(false); }
  };

  const startTimer = () => {
    setTimer(300);
  };

  function tratarErro(error: AxiosError<ApiError>) {
    setMessageAlerta(tratarErroApi(error, 'Não foi possível realizar o Cadastro: '));
    setShowAlerta(true);
  }

  if (logado && !tokenExpirado(token)) return <Redirect to='/' />;

  const currentLeft = stepLeftContent[step - 1];
  const docMask = tipoPessoa === 'PF' ? '999.999.999-99' : '99.999.999/9999-99';
  const docPlaceholder = tipoPessoa === 'PF' ? '000.000.000-00' : '00.000.000/0000-00';

  return (
    <PageWrapper>
      {/* ===== PAINEL ESQUERDO ===== */}
      <LeftPanel>
        <LeftOverlay />
        <FloatingCircle size="140px" top="10%" left="5%" delay="0s" />
        <FloatingCircle size="90px" top="55%" left="80%" delay="2s" />
        <FloatingCircle size="70px" top="75%" left="15%" delay="3.5s" />

        <LeftContent>
          <LeftLogo>
            <LeftLogoImg src={logo} alt="LocaSmartPro" />
            <LeftLogoText>LocaSmartPro</LeftLogoText>
          </LeftLogo>

          <LeftStepInfo key={step}>
            <LeftStepNumber>
              <FaRocket size={11} /> {currentLeft.badge}
            </LeftStepNumber>
            <LeftTitle>{currentLeft.title}</LeftTitle>
            <LeftDescription>{currentLeft.description}</LeftDescription>

            {currentLeft.type === 'features' && (
              <FeatureGrid>
                <FeatureCard>
                  <FeatureCardIcon><FaCar /></FeatureCardIcon>
                  <FeatureCardTitle>Gestão de Aluguéis</FeatureCardTitle>
                  <FeatureCardDesc>Contratos e locações</FeatureCardDesc>
                </FeatureCard>
                <FeatureCard>
                  <FeatureCardIcon><FaChartBar /></FeatureCardIcon>
                  <FeatureCardTitle>Relatórios</FeatureCardTitle>
                  <FeatureCardDesc>Dashboards e métricas</FeatureCardDesc>
                </FeatureCard>
                <FeatureCard>
                  <FeatureCardIcon><FaMobileAlt /></FeatureCardIcon>
                  <FeatureCardTitle>App do Locatário</FeatureCardTitle>
                  <FeatureCardDesc>Acompanhamento mobile</FeatureCardDesc>
                </FeatureCard>
                <FeatureCard>
                  <FeatureCardIcon><FaCogs /></FeatureCardIcon>
                  <FeatureCardTitle>Manutenções</FeatureCardTitle>
                  <FeatureCardDesc>Preventivas e corretivas</FeatureCardDesc>
                </FeatureCard>
              </FeatureGrid>
            )}

            {currentLeft.type === 'ready' && (
              <FeatureGrid>
                <FeatureCard>
                  <FeatureCardIcon><FaCheck /></FeatureCardIcon>
                  <FeatureCardTitle>Teste grátis</FeatureCardTitle>
                  <FeatureCardDesc>Sem cartão de crédito</FeatureCardDesc>
                </FeatureCard>
                <FeatureCard>
                  <FeatureCardIcon><FaRocket /></FeatureCardIcon>
                  <FeatureCardTitle>Pronto para usar</FeatureCardTitle>
                  <FeatureCardDesc>Configuração em minutos</FeatureCardDesc>
                </FeatureCard>
              </FeatureGrid>
            )}
          </LeftStepInfo>
        </LeftContent>
      </LeftPanel>

      {/* ===== PAINEL DIREITO ===== */}
      <RightPanel>
        <FormContainer>
          <MobileLogo>
            <MobileLogoImg src={logo} alt="LocaSmartPro" />
            <MobileLogoText>LocaSmartPro</MobileLogoText>
          </MobileLogo>

          <ProgressBar>
            <ProgressSegment active={step === 1} done={step > 1} />
            <ProgressSegment active={step === 2} done={step > 2} />
            <ProgressSegment active={step === 3} done={false} />
          </ProgressBar>
          <ProgressLabels>
            <ProgressLabel active={step === 1}>{tipoPessoa === 'PJ' ? 'Empresa' : 'Negócio'}</ProgressLabel>
            <ProgressLabel active={step === 2}>Seus dados</ProgressLabel>
            <ProgressLabel active={step === 3}>Senha</ProgressLabel>
          </ProgressLabels>

          <Form onSubmit={handleSubmit(onSubmit)} style={{ marginTop: 28 }}>

            {/* ===== STEP 1 ===== */}
            {step === 1 && (
              <StepContent key="s1">
                <StepHeader>
                  <StepTitle>{tipoPessoa === 'PJ' ? 'Dados da empresa' : 'Dados do negócio'}</StepTitle>
                  <StepDescription>
                    {tipoPessoa === 'PJ'
                      ? 'Digite o CNPJ que os dados serão preenchidos automaticamente'
                      : 'Informe seu CPF e o nome do seu negócio'}
                  </StepDescription>
                </StepHeader>

                <ToggleRow>
                  <ToggleContainer>
                    <ToggleOption active={tipoPessoa === 'PJ'} onClick={() => handleTipoPessoaChange('PJ')} type="button">Pessoa Jurídica</ToggleOption>
                    <ToggleOption active={tipoPessoa === 'PF'} onClick={() => handleTipoPessoaChange('PF')} type="button">Pessoa Física</ToggleOption>
                  </ToggleContainer>
                </ToggleRow>

                <FieldGroup>
                  <Label>{tipoPessoa === 'PF' ? 'CPF' : 'CNPJ'}</Label>
                  <InputWrapper>
                    <Icon><FaIdCard /></Icon>
                    <MaskedInput
                      inputRef={register({ required: true })}
                      name="documento"
                      type="text"
                      mask={docMask}
                      placeholder={docPlaceholder}
                      required
                      autoFocus
                      value={documentoInput}
                      onChange={(e: any) => handleDocumentoChange(e)}
                      onBlur={handleDocumentoBlur}
                    />
                  </InputWrapper>
                  {cnpjStatus === 'loading' && <Badge type="loading">Buscando dados<SmallSpinner /></Badge>}
                  {cnpjStatus === 'found' && <Badge type="success"><FaCheck size={10} /> Empresa encontrada</Badge>}
                  {cnpjStatus === 'not_found' && <Badge type="error">CNPJ não encontrado na Receita Federal</Badge>}
                </FieldGroup>

                <FieldGroup>
                  <Label>{tipoPessoa === 'PJ' ? 'Nome da empresa' : 'Nome do negócio'}</Label>
                  <InputWrapper>
                    <Icon><FaBuilding /></Icon>
                    <Input
                      ref={register({ required: true })}
                      name="empresa"
                      type="text"
                      placeholder={tipoPessoa === 'PJ' ? 'Razão social ou nome fantasia' : 'Como se chama seu negócio'}
                      required
                      value={nomeEmpresaInput}
                      onChange={(e) => setNomeEmpresaInput(e.target.value)}
                    />
                  </InputWrapper>
                </FieldGroup>

                <FieldGroup>
                  <Label>Quantos veículos sua frota possui atualmente?</Label>
                  <InputWrapper>
                    <Icon><FaCar /></Icon>
                    <Input
                      type="number"
                      name="quantidadeVeiculos"
                      placeholder="Ex: 10"
                      min={1}
                      required
                      value={quantidadeVeiculosInput || ''}
                      onChange={(e) => setQuantidadeVeiculosInput(Number(e.target.value))}
                    />
                  </InputWrapper>
                </FieldGroup>

                <ButtonRow>
                  <BtnPrimary type="button" disabled={!isStep1Valid()} onClick={nextStep}>
                    Continuar <FaArrowRight size={13} />
                  </BtnPrimary>
                </ButtonRow>
              </StepContent>
            )}

            {/* ===== STEP 2 ===== */}
            {step === 2 && (
              <StepContent key="s2">
                <StepHeader>
                  <StepTitle>Seus dados</StepTitle>
                  <StepDescription>Informações do administrador da conta</StepDescription>
                </StepHeader>

                <FieldGroup>
                  <Label>Nome completo</Label>
                  <InputWrapper>
                    <Icon><FaUser /></Icon>
                    <Input
                      ref={register({ required: true })}
                      name="nomeUsuario"
                      type="text"
                      placeholder="Seu nome"
                      required
                      autoFocus
                      value={nomeUsuarioInput}
                      onChange={(e) => setNomeUsuarioInput(e.target.value)}
                    />
                  </InputWrapper>
                </FieldGroup>

                <FieldGroup>
                  <Label>Telefone / WhatsApp</Label>
                  <InputWrapper>
                    <Icon><FaPhone /></Icon>
                    <MaskedInput
                      inputRef={register({ required: true })}
                      name="telefone"
                      type="tel"
                      mask="(99) 99999-9999"
                      placeholder="(00) 00000-0000"
                      required
                      value={telefoneInput}
                      onChange={(e: any) => setTelefoneInput(e.target.value)}
                    />
                  </InputWrapper>
                </FieldGroup>

                <FieldGroup>
                  <Label>E-mail de acesso</Label>
                  <InputWrapper>
                    <Icon><FaEnvelope /></Icon>
                    <Input
                      ref={register({ required: true })}
                      name="email"
                      type="email"
                      placeholder="seu@email.com"
                      required
                      value={emailInput}
                      onChange={(e) => setEmailInput(e.target.value)}
                    />
                  </InputWrapper>
                </FieldGroup>

                <ButtonRow>
                  <BtnSecondary type="button" onClick={prevStep}><FaArrowLeft size={13} /> Voltar</BtnSecondary>
                  <BtnPrimary type="button" disabled={!isStep2Valid()} onClick={nextStep}>
                    Continuar <FaArrowRight size={13} />
                  </BtnPrimary>
                </ButtonRow>
              </StepContent>
            )}

            {/* ===== STEP 3 ===== */}
            {step === 3 && (
              <StepContent key="s3">
                <StepHeader>
                  <StepTitle>Crie sua senha</StepTitle>
                  <StepDescription>Escolha uma senha segura para acessar sua conta</StepDescription>
                </StepHeader>

                <FieldGroup>
                  <Label>Senha</Label>
                  <InputWrapper>
                    <Icon><FaLock /></Icon>
                    <Input
                      ref={register({ required: true })}
                      name="senha"
                      type={showPassword ? 'text' : 'password'}
                      placeholder="Mínimo 6 caracteres"
                      required
                      autoFocus
                      value={senhaInput}
                      onChange={(e) => setSenhaInput(e.target.value)}
                    />
                    <TogglePasswordIcon onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </TogglePasswordIcon>
                  </InputWrapper>
                </FieldGroup>

                <FieldGroup>
                  <Label>Confirme a senha</Label>
                  <InputWrapper>
                    <Icon><FaLock /></Icon>
                    <Input
                      ref={register({ required: true })}
                      name="confirmaSenha"
                      type={showPassword ? 'text' : 'password'}
                      placeholder="Digite novamente"
                      required
                      value={confirmaSenhaInput}
                      onChange={(e) => setConfirmaSenha(e.target.value)}
                    />
                  </InputWrapper>
                  {confirmaSenhaInput && senhaInput !== confirmaSenhaInput && <Badge type="error">As senhas não coincidem</Badge>}
                  {confirmaSenhaInput && senhaInput === confirmaSenhaInput && <Badge type="success"><FaCheck size={10} /> Senhas conferem</Badge>}
                </FieldGroup>

                <TermsText>
                  Ao criar sua conta, você concorda com nossos{' '}
                  <a href="/termos-de-uso" target="_blank">Termos de Uso</a> e{' '}
                  <a href="/politica-de-privacidade" target="_blank">Política de Privacidade</a>
                </TermsText>

                <ButtonRow>
                  <BtnSecondary type="button" onClick={prevStep}><FaArrowLeft size={13} /> Voltar</BtnSecondary>
                  <BtnPrimary type="submit" disabled={!isStep3Valid() || isSubmitting}>
                    {isSubmitting ? 'Processando...' : 'Criar minha conta'}
                  </BtnPrimary>
                </ButtonRow>
              </StepContent>
            )}
          </Form>

          <FooterLink>Já tem uma conta? <a href="login">Fazer login</a></FooterLink>
        </FormContainer>
      </RightPanel>

      <VerificacaoModal
        show={showVerificationModal} onHide={() => setShowVerificationModal(false)}
        onCodeSubmit={validarCodigo} timer={timer} onResend={gerarCodigoVerificacao}
      />
      <ModalAlerta show={showAlerta} message={messageAlerta} onHide={() => setShowAlerta(false)} />
      <ProgressBarModal carregando={carregando} titulo="Processando..." />
      <ModalAviso
        type={tipoModalAviso} messageAviso={messageAviso} show={showModalAviso}
        onClose={() => { tipoModalAviso === 'aprovado' ? window.location.href = '/' : setShowModalAviso(false); }}
      />
    </PageWrapper>
  );
}

export default Cadastrar;
